function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21 15.912c-1.19.015-2.243.218-3.242.49-.058-1.517-.35-4.732-1.74-7.071 2.414.104 4.399.782 4.399.782-.566-1.1-1.795-2.11-3.4-2.819 2-1.195 3.976-1.581 3.976-1.581-1.173-.7-2.755-.944-4.52-.595 1.167-1.905 2.682-3.216 2.682-3.216-1.896-.01-4.206 1.157-5.972 3.087-2.462-1.068-5.127-1.172-6.88-.344 0 0 2.17.618 4.133 2.016-2.081.618-3.73 1.685-4.482 2.908 0 0 2.577-.71 5.447-.556-.829 1.182-1.294 2.4-1.298 3.458 0 0 1.406-1.449 3.447-2.627 1.594 2.493 1.008 5.909.543 7.66-.912.23-1.867.392-2.931.392-3.729 0-4.311-3.576-1.328-2.984.274-1.225-2.458-2.858-4.588-1.225C4.28 14.43 3.576 14.75 3 14.88v5.983l18 .033v-4.982z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationBeach = function SvgLocationBeach(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationBeach;